// Utilidades para manejo de estado en el quiz
// Función para obtener el estado del juego
export const obtenerEstadoJuego = (estado) => {
  const estadoConcurso = {
    preguntaActual: estado.preguntaActual,
    respuestaSeleccionada: estado.respuestaSeleccionada,
    respuestaRevelada: estado.respuestaRevelada,
    respuestas: estado.respuestas,
    puntuacion: estado.puntuacion,
    juegoTerminado: estado.juegoTerminado,
    respuestasMezcladas: estado.respuestasMezcladas,
    respuestasEliminadas: estado.respuestasEliminadas[estado.preguntaActual] || [],
    respuestasVisibles: estado.respuestasVisibles,
    comodines: estado.comodines,
    tiempoRestante: estado.tiempoRestante,
    tiempoLlamada: estado.tiempoLlamada,
    temporizadorLlamadaActivo: estado.temporizadorLlamadaActivo,
    mostrarTemporizadorLlamada: estado.mostrarTemporizadorLlamada,
    mostrarGraficoPublico: estado.mostrarGraficoPublico,
    datosGraficoPublico: estado.datosGraficoPublico,
    tiempoRestantePublico: estado.tiempoRestantePublico,
    temporizadorPublicoActivo: estado.temporizadorPublicoActivo,
    votosPublico: estado.votosPublico,
    pregunta: estado.preguntas[estado.preguntaActual],
    indiceRespuestaCorrecta: estado.indiceRespuestaCorrecta,
    duracionConcurso: estado.duracionConcurso
  };

  return estadoConcurso;
};
